import React, { Component } from 'react';

class MapPointsMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Pontos notáveis </h2>
                <p>
                    Nesta página encontra todos os pontos notáveis disponíveis no operador na edição ativa na data selecionada.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Crir um ponto notável e associá-lo á uma paragem na rede ativa e na rede de rascunho</li>
                    <li>Pesquisar os pontos notáveis disponíveis na rede ativa e na rede de rascunho</li>
                    <li>Editar pontos notáveis na rede ativa e na de rascunho</li>
                    <li>Eliminar pontos notáveis na rede ativa e na de rascunho</li>
                    <li>Comparar os pontos notáveis da rede ativa com os pontos notáveis do rascunho </li>
                </ul>
            </div>
        );
    }
}

export default MapPointsMetadata;